import { api } from '@/services/api'
export default {
  name: 'FormWrapper',
  props: {
    disabled: { type: Boolean, default: false },
    config: {
      type: Object,
      default: () => {
        return {
          id: '', // grid ID
          api: '', // api for load data
          title: '', // title for form,
          isVisibleWhenNew: true
        }
      }
    },
    defaultData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      api: this.config.api || '',
      // flags
      isVisible: false,
      isVisibleWhenNew: (this.config.isVisibleWhenNew !== undefined) ? this.config.isVisibleWhenNew : true,
      isLoading: false,
      isEditMode: true,
      // states
      state: null,
      currentID: null,
      data: { ...this.defaultData },
      formData: {},
      // View data (from selects), Example: { partNumber: '232-23-xx' }
      viewData: {}
    }
  },
  watch: {
    '$route': 'handlerRoute',
    defaultData: 'handlerDefaultData',
    state: 'handleState',
    currentID: 'handleCurrentID',
    isVisible (Value) {
      if (Value) {
        if (!this.$root.isMobile) {
          this.$nextTick(() => {
            if (this.$refs.Form && this.$refs.Form.$refs.firstField) {
              this.$refs.Form.$refs.firstField.focus()
            } else {
              setTimeout(() => {
                if (this.$refs.Form && this.$refs.Form.$refs.firstField) {
                  this.$refs.Form.$refs.firstField.focus()
                }
              }, 100)
            }
          })
        }
        this.$bus.$emit(`on-open-modal-${this.config.id}`)
        this.$emit('on-open')
      } else {
        this.$emit('on-close')
        this.$bus.$emit(`on-close-modal-${this.config.id}`)
      }
    }
  },
  computed: {
    title () {
      return this.config.title
        ? this.config.title
        : this.hasCreateNew
          ? this.L10n('edit')
          : this.L10n('add-new')
    },
    hasCreateNew () {
      return Boolean(Object.keys(this.data).length)
    }
  },
  mounted () {
    this.handlerRoute()
  },
  methods: {
    // HANDLERS
    // - ROUTE
    handlerRoute () {
      if (this.config.id && this.$route.query && this.$route.query[this.config.id]) {
        let value = this.$route.query[this.config.id]
        let start = value.indexOf('[')
        let end = value.indexOf(']')
        if (start !== -1 && end !== -1) {
          this.currentID = value.slice(start + 1, end)
          this.state = value.slice(0, start)
          this.isVisible = true
        } else {
          if (value === 'new') this.state = 'new'
          this.reset()
          if (this.isVisibleWhenNew) this.isVisible = true
        }
      } else {
        this.reset()
      }
    },
    handleFormData (Data) {
      this.formData = Data
    },
    handleViewData (data) {
      this.viewData = { ...this.viewData, ...data }
    },
    handlerDefaultData (Data) {
      this.data = { ...this.data, ...Data }
    },
    // -state
    handleState (state) {
      this.isEditMode = (/edit|new/g).test(state)
      this.handleChangeMode()
    },
    // -currentID
    handleCurrentID () {
      if (this.isVisible && this.currentID) {
        this.resetData()
        this.requestGetData()
        this.handleChangeID()
      } else {
        this.handleChangeReset()
      }
    },
    // -requests
    handleRequestDelete () {
      try {
        Promise
          .all(this.$refs.Form.$refs.form.mixinsComponents.map(component => component.handleDeleteAll()))
          .then(_ => {
            this.setQuery()
          })
      } catch {
        this.setQuery()
      }
    },
    checkUpdateMixins (Data, isEditAfter = false, status = 'update') {
      try {
        return Promise
          .all(this.$refs.Form.$refs.form.mixinsComponents.map(component => component.handleSave(Data)))
          .then(_ => {
            return this.handleEndCreateAndPath(Data, isEditAfter, status)
          })
      } catch {
        return this.handleEndCreateAndPath(Data, isEditAfter, status)
      }
    },
    handleEndCreateAndPath (Data, isEditAfter = false, status = 'update') {
      return Promise
        .resolve()
        .then(() => {
          if (isEditAfter) {
            this.currentID = Data.id
            this.setQuery('edit')
          } else {
            this.setQuery()
          }
        })
        .then(() => {
          return status === 'update'
            ? this.hookUpdated(Data)
            : this.hookCreated(Data)
        })
    },
    handleRequestGetData (Data) {
      this.data = Data
      this.handleChangeData()
      this.isLoading = false
      this.handleCameData(Data)
    },
    // METHODS
    // -helpers
    /**
     * @desc Prepare data to request update / create
     * @param data { Object } - form data
     * @param flag { String } - update or create response {update || create}
     * @returns {*}
     */
    handlePrepareData (data, flag = 'update') {
      // When form data clears where field is someID we have an error because value has a string value ('') but should be null
      return this.correctDataWithFieldID(data)
    },
    /**
     * @desc Hook change data ( request )
     */
    handleChangeData () {
    },
    handleCameData (data) {
    },
    handleErrorCameData () {
    },
    handleChangeID () {
    },
    handleChangeMode () {
    },
    handleChangeReset () {
    },
    handleReset () {
    },
    handleClose () {
    },
    handleBack () {
    },
    hookCreated (data) {
    },
    hookUpdated () {
    },
    // -controls
    setCommand (Command) {
      switch (Command) {
        case 'delete':
          this.delete()
          break
        case 'save':
          this.save()
          break
        case 'save_edit':
          this.save(true)
          break
        case 'back':
          this.back()
          break
        case 'cancel':
          this.setQuery()
          this.handleClose()
          break
      }
    },
    // -resets
    reset () {
      this.currentID = null
      this.isVisible = false
      this.isLoading = false
      this.isEditMode = true
      this.state = 'new'
      this.resetData()
      this.handleReset()
    },
    resetData () {
      if (this.$refs.Form) this.$refs.Form.resetForm()
      this.formData = {}
      this.data = { ...this.defaultData }
      this.viewData = {}
    },
    // -query
    setQuery (Command) {
      if (Command) {
        if (this.currentID) {
          let query = Object.assign({}, this.$route.query, { [this.config.id]: `${Command}[${this.currentID}]` })
          this.$router.replace({ query })
        } else {
          this.isEditMode = (Command === 'edit')
        }
      } else {
        let query = Object.assign({}, this.$route.query)
        delete query[this.config.id]
        this.$router.replace({ query: query })
      }
    },
    // -main
    refresh () {
      this.handleCurrentID()
    },
    back () {
      this.$bus.$emit('Refresh-Grid', { id: this.config.id })
      this.setQuery()
      this.handleBack()
    },
    delete () {
      this.$bus.$emit(`Call-Grid-Delete-${this.config.id}`,
        { _formTitle: this.formTitle, ...this.$refs.Form.getData() },
        (response) => {
          if (response !== 'cancel') {
            this.handleRequestDelete(response.data)
          }
        }
      )
    },
    save (isEditAfter = false) {
      if (!this.$refs.Form) {
        // eslint-disable-next-line
        return console.error('not found form')
      }
      // validate
      this.$refs.Form.validate()
        .then(() => {
          this.isLoading = true
          // check to save execute components
          this.checkExecuteFirst().then(_ => {
            // save/create main object
            if (this.currentID) {
              // update
              this.$bus.$emit(`Call-Grid-Patch-${this.config.id}`,
                this.handlePrepareData(this.$refs.Form.getData(), 'update'),
                response => this.gridPatchHandler(response, isEditAfter)
              )
            } else {
              // create
              this.$bus.$emit(`Call-Grid-Create-${this.config.id}`,
                this.handlePrepareData(this.$refs.Form.getData(), 'create'),
                response => this.gridCreateHandler(response, isEditAfter)
              )
            }
          })
        })
        .catch(() => this.setQuery('edit'))
    },
    /**
     * @desc save all components before path/create main object (example image uploader)
     * @return {Promise<unknown>}
     */
    checkExecuteFirst () {
      return new Promise(resolve => {
        try {
          Promise
            .all(this.$refs.Form.$refs.form.executeFirstComponents.map(component => component.handleSave()))
            .then(resolve)
        } catch {
          resolve()
        }
      })
    },
    async gridPatchHandler (response, isEditAfter) {
      try {
        if (response !== 'Error') {
          await this.checkUpdateMixins(response.data, isEditAfter, 'update')
        }
      } finally {
        this.isLoading = false
      }
    },
    async gridCreateHandler (response, isEditAfter) {
      try {
        if (response !== 'Error') {
          await this.checkUpdateMixins(response.data, isEditAfter, 'create')
        }
      } finally {
        this.isLoading = false
      }
    },
    // REQUESTS
    requestGetData () {
      if (this.currentID) {
        this.isLoading = true

        api
          .get(`${this.api}${this.currentID}`, { requestId: `FormGet-${this._uid}` })
          .then(response => {
            this.handleRequestGetData(response.data)
          })
          .catch(error => {
            // eslint-disable-next-line
            this.handleErrorCameData(error)
            console.error(error)
          })
      }
    }
  }
}
